<template>
  <b-card no-body class="h-100">
    <b-card-body>
      <b-overlay :show="loading" opacity="0.5">
        <b-row class="align-items-top">
          <b-col :md="leftCols" class="position-relative">
            <h6 class="card-title mb-2">{{ leftTitle }}</h6>
            <b-media no-body>
              <b-media-aside class="mr-1">
                <b-avatar size="36" :variant="leftAvatarVariant">
                  <feather-icon size="20" :icon="leftIcon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h1 class="font-weight-bolder mb-0">{{ (normalizedTotal) | number }}</h1>
                <b-card-text class="font-small-3 mb-0">{{ totalUnit }}</b-card-text>
              </b-media-body>
            </b-media>
            <div class="position-absolute" style="top: 10px; right: 10px;">
              <b-spinner v-if="leftLoading" small />
            </div>

            <div v-if="!loading" class="mt-2">
              <div
                v-for="(it, idx) in leftItems"
                :key="`cd-item-${idx}`"
                class="d-flex justify-content-between mb-1"
              >
                <div class="series-info d-flex align-items-center">
                  <span class="font-weight-bolder mr-50">{{ it.label }}</span>
                </div>
                <div>
                  <span>{{ it.value | number }}</span>
                </div>
              </div>
            </div>
          </b-col>
          <b-col :md="rightCols">
            <h5 class="card-title mb-2">{{ title }}</h5>
            <vue-apex-charts
              type="donut"
              :height="apexHeight"
              class="my-1"
              :options="chartOptions"
              :series="series"
            />
          </b-col>
        </b-row>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BOverlay, BRow, BCol, BMedia, BMediaAside, BMediaBody, BAvatar, BCardText, BSpinner,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  name: 'UserInfoSourcesCard',
  components: {
    BCard,
    BCardBody,
    BOverlay,
    BRow,
    BCol,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BCardText,
    BSpinner,
    VueApexCharts,
  },
  props: {
    title: {
      type: String,
      default: 'Donut Chart',
    },
    // Left side configuration
    leftTitle: {
      type: String,
      default: 'Total Pengguna',
    },
    total: {
      type: [Number, String],
      default: null,
    },
    totalUnit: {
      type: String,
      default: 'orang',
    },
    leftLoading: {
      type: Boolean,
      default: false,
    },
    leftIcon: {
      type: String,
      default: 'UserIcon',
    },
    leftAvatarVariant: {
      type: String,
      default: 'light-primary',
    },
    leftCols: {
      type: [Number, String],
      default: 6,
    },
    rightCols: {
      type: [Number, String],
      default: 6,
    },
    items: {
      // [{ label, value }]
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      default: () => [$themeColors.primary, $themeColors.warning, $themeColors.danger, $themeColors.info, $themeColors.success, $themeColors.secondary],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    apexHeight: {
      type: [Number, String],
      default: 300,
    },
    donutSize: {
      type: String,
      default: '70%',
    },
  },
  computed: {
    series() {
      return this.items.map(it => Number(it.value) || 0)
    },
    labels() {
      return this.items.map(it => it.label)
    },
    leftItems() {
      const items = Array.isArray(this.items) ? this.items : []
      if (items.length <= 3) return items
      const firstThree = items.slice(0, 3)
      const othersSum = items.slice(3).reduce((a, b) => a + (Number(b.value) || 0), 0)
      const withOthers = [...firstThree]
      if (othersSum > 0) withOthers.push({ label: 'Lainnya', value: othersSum })
      return withOthers
    },
    normalizedTotal() {
      if (this.total !== null && this.total !== undefined && this.total !== '') {
        const n = Number(this.total)
        return Number.isFinite(n) ? n : 0
      }
      return this.series.reduce((a, b) => a + (Number(b) || 0), 0)
    },
    chartOptions() {
      return {
        chart: { toolbar: { show: false } },
        labels: this.labels,
        dataLabels: { enabled: false },
        legend: { show: false },
        stroke: { width: 0 },
        colors: this.colors,
        plotOptions: {
          pie: {
            donut: { size: this.donutSize },
          },
        },
      }
    },
  },
}
</script>

<style scoped>
</style>
